export default __webpack_public_path__ + "static/media/solarPower.0ef74982.webp";